<!--
 * @Descripttion: 报表
 * @Author: chenjinsheng
 * @Date: 2021-10-26 11:01:32
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-10-26 14:24:52
-->

<template>
    <div class="page-monitoring-page">
        <iframe
            v-if="url"
            :src="url"
            frameborder="0"
            allowfullscreen="allowfullscreen"
            style="background-color:transparent;width: 100%; min-height: 100%;"
        ></iframe>
        <div v-else class="no-empty">
            <img src="http://jcyy.newhope.cn/static/img/empty.0bea7e0b.svg" alt="" /><span>暂无数据，请选择项目</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "ReportContent",
    props: {
        url: {
            type: String,
            default: "",
        },
    },
};
</script>

<style lang="scss" scoped>
.page-monitoring-page {
    height: 100%;
    .no-empty {
        display: flex;
        width: 100%;
        height: 100%;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }
}
</style>
